



































import Vue from 'vue'
import { mapGetters } from 'vuex'
import SidebarDetails from '@/calendesk/models/SidebarDetails'
import Sidebar from '@/calendesk/models/Sidebar'
import { SidebarType } from '@/calendesk/models/BuilderTypes'
import { rememberOpenPanels } from '@/builder/sidebar/settingGroupState'
import { SidebarDetailsType } from '@/builder/sidebar/sidebarDetails/SidebarDetailsType'
import PreviewTapHint from '@/components/PreviewTapHint.vue'
import colors from '@/lib/calendesk-js-library/styles/colors'
import {
  COOKIE_BANNER_CONFIGURATION_ID,
  COOKIE_BANNER_CONFIGURATION_KEY,
  COOKIE_BANNER_ENABLED_KEY,
  PRIVACY_POLICY_TARGET_KEY,
  PrivacyPolicyTarget,
  defaultTextTranslationKey
} from '@/calendesk/models/CookieBannerSettings'

function isLightColor (hex: string): boolean {
  const match = (hex || '').trim().match(/^#?([0-9a-f]{6})$/i)

  if (!match) {
    return false
  }

  const value = parseInt(match[1], 16)
  return (((value >> 16) & 255) * 299 + ((value >> 8) & 255) * 587 + (value & 255) * 114) / 1000 > 160
}

// A still picture of the bar the visitor will see, drawn from the same texts and
// colours the published site uses. Clicking it opens the texts editor, the way
// clicking a section opens its settings.
export default Vue.extend({
  name: 'CookieBannerPreview',
  components: { PreviewTapHint },
  data () {
    return {
      hover: false
    }
  },
  computed: {
    ...mapGetters({
      configuration: 'builder/getDraftConfiguration'
    }),
    enabled (): boolean {
      return this.configuration[COOKIE_BANNER_ENABLED_KEY] === true
    },
    texts (): Record<string, any> {
      return this.configuration[COOKIE_BANNER_CONFIGURATION_KEY] || {}
    },
    primary (): string {
      return this.configuration.wb_color_primary__color__ || colors.blue
    },
    hasPrivacyLink (): boolean {
      const target = this.texts[PRIVACY_POLICY_TARGET_KEY]?.value

      return (target === PrivacyPolicyTarget.URL && Boolean(this.texts.wb_cookie_banner_privacy_policy_url__url__)) ||
        (target === PrivacyPolicyTarget.PAGE && Boolean(this.texts.wb_cookie_banner_privacy_policy_page__page_id__))
    },
    barStyle (): Record<string, string> {
      return {
        background: this.configuration.wb_color_bg__color__ || colors.background,
        color: this.configuration.wb_color_text__color__ || colors.dark
      }
    },
    primaryButtonStyle (): Record<string, string> {
      return {
        background: this.primary,
        borderColor: this.primary,
        color: isLightColor(this.primary) ? colors.dark : colors.background
      }
    },
    secondaryButtonStyle (): Record<string, string> {
      return {
        borderColor: this.primary,
        color: this.primary
      }
    }
  },
  methods: {
    text (key: string): string {
      const value = this.texts[key]
      return typeof value === 'string' && value.trim() !== '' ? value : this.$trans(defaultTextTranslationKey(key))
    },
    edit (): void {
      // Same as clicking a section: the main sidebar opens on the tab that owns
      // the setting (General, advanced group), then the banner panel on top.
      rememberOpenPanels(['general:advanced'], [0])
      this.$store.dispatch('sidebar/openSidebar', new Sidebar(true, SidebarType.GENERAL, this.$trans('wb_general')))
      this.$store.dispatch('builder/setExternalConfiguration', COOKIE_BANNER_CONFIGURATION_ID)
      this.$store.dispatch('sidebar/openSidebarDetails', new SidebarDetails(true, SidebarDetailsType.COOKIE_BANNER, {}))
    }
  }
})
